import { render, staticRenderFns } from "./TaskAddedCollaborators.vue?vue&type=template&id=f2d54a7e&scoped=true"
import script from "./TaskAddedCollaborators.vue?vue&type=script&lang=js"
export * from "./TaskAddedCollaborators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d54a7e",
  null
  
)

export default component.exports